import React from 'react';
import { AccessibilityClickableDiv } from '@skillz/accessibility';
import Icon from '../icons/Icon';
import iconsList from '../icons/iconsList';
import Text from '../../features/text/Text';
import classes from './PageHeaderBar.module.css';

const PageHeaderBar = ({ title, icon, image, onBack, className, endContent }) => {

    return (
        <header className={`${classes.Header} ${className || ''}`}>
            <div className={classes.StartContent}>
                {onBack &&
                    <AccessibilityClickableDiv onClick={onBack} className={classes.BackButton} >
                        <Icon name={iconsList.back} color="black" size="20px" />
                    </AccessibilityClickableDiv>
                }
                <div className={classes.HeaderContent}>
                    {image && <img src={image} alt="" className={classes.PageImage} />}
                    {!image && icon && <Icon name={icon} size="28px" color="#6300FF" className={classes.PageIcon} />}
                    {title && <Text className={classes.Title}>{title}</Text>}
                </div>
            </div>
            {endContent && <div className={classes.EndContent}>{endContent}</div>}
        </header>
    );
};

export default PageHeaderBar;
